<template>
  <UIButtonIcon
    v-tooltip="copyTooltip"
    :leading="copyIcon"
    class="ui-button-copy"
    :class="buttonClasses"
    @click="handleCopy"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useTimeout } from '@vueuse/core'

import UIButtonIcon from './ButtonIcon.vue'
import { CheckIcon, ClipboardDocumentIcon } from '@heroicons/vue/24/outline'

type Props = {
  text: string
}

const props = defineProps<Props>()

const { start, isPending } = useTimeout(3000, {
  controls: true,
  immediate: false,
})

const copyIcon = computed(() =>
  isPending.value ? CheckIcon : ClipboardDocumentIcon,
)

const copyTooltip = computed(() => (isPending.value ? 'Copied' : undefined))

const buttonClasses = computed(() => ({
  'ui-button-copy--copied': isPending.value,
}))

const handleCopy = () => {
  const blob = new Blob([props.text], { type: 'text/plain' })
  navigator.clipboard.write([
    new ClipboardItem({
      [blob.type]: blob,
    }),
  ])
  start()
}
</script>

<style>
.ui-button-copy {
  &--copied {
    .ui-button {
      @apply text-green-600! dark:text-green-300!;
    }
  }
}
</style>
